// extracted by mini-css-extract-plugin
module.exports = {"container":"e_0sb","tab":"e_1sb","current":"e_2sb"};